import React from 'react';
import {BrokenImage} from "@material-ui/icons";
import Translator from 'Languages/Utility/Translator';
import { useTranslation } from 'react-i18next';

function EmptyData(props) {
    const { t } = useTranslation();
    return (
        <div className="emptyData">
            <BrokenImage/>
            <strong>{t('_noDataText')}</strong>
        </div>
    );
}

export default EmptyData;